import Stack, { StackProps } from 'app/components/base/Stack'
import SelectFilter from 'app/libs/elastic/filters/SelectFilter'
import { getAttributionOptions } from 'app/services/Api/listing'
import { IS_NATIVE_APP } from 'app/utils/constants/env.constants'

interface AttributeFiltersProps {
  attributions?: Attribution[]
  stackProps?: StackProps
}

const AttributeFilters: RFC<AttributeFiltersProps> = ({
  attributions,
  stackProps
}) => {
  return (
    <Stack {...stackProps}>
      {attributions?.map(({ id, name, key }, index) => {
        const isLastItem = attributions?.length === index + 1
        const isDivider = IS_NATIVE_APP && !isLastItem

        const field = `${key}.keyword`

        return (
          <SelectFilter
            key={id}
            field={field}
            filterType="any"
            optionSettings={{
              key: id,
              enabled: !!id,
              loadOptions: () =>
                getAttributionOptions({ by_attribution_id: id }),
              optionValue: 'name'
            }}
            sx={{ width: { xs: '100%', md: 169 } }}
            divider={isDivider}
            sortOption
            label={name}
            withOptions
            withFilter
          />
        )
      })}
    </Stack>
  )
}

export default AttributeFilters
